<template>
  <div class="page">
    <van-nav-bar title="日志核验" left-arrow @click-left="$router.back()"/>
    <van-tabs v-model="tab" color="#D32F2F" title-active-color="#D32F2F" @change="load">
      <van-tab title="待核验"/>
      <van-tab title="已处理"/>
    </van-tabs>
    <van-skeleton v-if="loading" title :row="7"/>
    <main v-else>
      <article v-for="item in rows" :key="item.worklogId" @click="$router.push({name:'SupervisorReview',params:{id:item.worklogId}})">
        <div class="avatar">{{ item.employeeName.slice(-1) }}</div>
        <div class="copy"><b>{{ item.employeeName }} · {{ item.positionName }}</b><span>{{
            item.workDate
          }} {{ item.cadence === 'MONTHLY' ? '周报' : '日报' }}</span><small>{{ summary(item) }}</small></div>
        <i :class="item.review ? 'done' : 'wait'">{{ item.review ? '已处理' : '待核验' }}</i>
      </article>
      <van-empty v-if="!rows.length" :description="tab ? '暂无已处理日志' : '暂无待核验日志'"/>
    </main>
  </div>
</template>

<script>
/**
 * 主管待核验列表：待处理 / 已处理 Tab；查询范围为主管可见的全部历史日志。
 * MONTHLY 在后端存周报。
 */
import coreapi from '@/utils/coreapi';

export default {
  data() {
    return {tab: 0, rows: [], loading: false};
  },
  mounted() {
    this.load();
  },
  activated() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        // 待核验列表不再按当前月份截断，确保主管能处理全部历史提交。
        const all = await coreapi.supervisorReviews(this.tab === 1);
        this.rows = this.tab ? all.filter(item => item.review) : all;
      } catch (e) {
        this.$toast.fail(e.message);
      } finally {
        this.loading = false;
      }
    },
    /** 列表摘要：优先解析 dailyLogs / monthlyAchievements JSON */
    summary(item) {
      const values = item.fieldValues || {};
      if (values.dailyLogs) {
        try {
          const parsed = JSON.parse(values.dailyLogs);
          if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
            const today = parsed.today || [];
            return today.filter(Boolean).join('；') || '查看详情';
          }
          if (Array.isArray(parsed)) return parsed.filter(Boolean).join('；') || '查看详情';
        } catch (e) {
          return values.dailyLogs;
        }
      }
      if (values.monthlyAchievements) {
        try {
          const parsed = JSON.parse(values.monthlyAchievements);
          if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
            const thisWeek = parsed.thisWeek || [];
            return thisWeek.filter(Boolean).join('；') || '查看详情';
          }
          if (Array.isArray(parsed)) return parsed.filter(Boolean).join('；') || '查看详情';
        } catch (e) {
          return values.monthlyAchievements;
        }
      }
      return Object.values(values)[0] || '查看详情';
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/assets/base.less";
@import "./supervisor.less";

.page {
  min-height: 100vh;
  background: #f6f7fb;
  color: #333;
  letter-spacing: 0
}

.page /deep/ .van-tabs__wrap {
  height: .92rem
}

.page /deep/ .van-tab {
  color: #8a8da3;
  font-size: .29rem
}

.page /deep/ .van-tab--active {
  color: @color;
  font-weight: 600
}

.page /deep/ .van-tabs__line {
  width: .56rem;
  background: @color
}

main {
  padding: .25rem .28rem
}

article {
  margin-bottom: .16rem;
  padding: .25rem;
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: .2rem;
  box-shadow: 0 .06rem .24rem rgba(211, 47, 47, .08)
}

.avatar {
  flex: 0 0 .78rem;
  width: .78rem;
  height: .78rem;
  line-height: .78rem;
  margin-right: .2rem;
  text-align: center;
  color: #fff;
  border-radius: 50%;
  background: @color;
  box-shadow: 0 .06rem .16rem rgba(211, 47, 47, .2);
  font-size: .28rem;
  white-space: nowrap;
  overflow: hidden
}

.copy {
  min-width: 0;
  flex: 1
}

.copy b, .copy span, .copy small {
  display: block
}

.copy b {
  color: #34364a;
  font-size: .31rem
}

.copy span {
  margin-top: .05rem;
  color: #777b90;
  font-size: .25rem
}

.copy small {
  margin-top: .06rem;
  overflow: hidden;
  color: #a0a2b0;
  font-size: .23rem;
  text-overflow: ellipsis;
  white-space: nowrap
}

article i {
  padding: .08rem .13rem;
  border-radius: .2rem;
  font-size: .23rem;
  font-style: normal
}

.wait {
  color: #a36b23;
  background: #fff3df
}

.done {
  color: #278653;
  background: #e8f7ef
}
</style>



// WEBPACK FOOTER //
// src/views/efficiency/supervisor/Reviews.vue